import React from "react";
import OpenSeadragon from "openseadragon";
import * as Utils from "../Shoothill.Core/Utils/Utils";

//declare var OpenSeadragon: any;

interface Props {
	id?: any;
	onZoom?: any;
	onMouseMove?: any;
	onOpen?: any;
	image: string;
	type?: string;
	showNavigator?: boolean;
}
export class OpenSeaDragonReact extends React.Component<Props> {
	public el: any = null;
	public elements: any = [];
	public viewer: OpenSeadragon.Viewer = {} as any;
	constructor(props: Props) {
		super(props);
	}

	public GetViewer = () => {
		return this.viewer;
	};

	// 	public validateElement = (e: any) => {
	// 	const props = ["id", "element", "x", "y", "width", "height"];
	// 	let isValid = true;
	// 	let errors = [];
	// 	for (prop of props) {
	// 		if (!(prop in e)) {
	// 			isValid = false;
	// 			errors.push(prop);
	// 		}
	// 	}
	// 	if (errors.length !== 0) {
	// 		console.log("Missing properties " + errors.join(", ") + ". Element was not added: ", e);
	// 	}
	// 	return isValid;
	// }

	public repositionElements = (es: any, viewer: any) => {
		for (let e of es) {
			this.repositionElement(e, viewer);
		}
	};

	public repositionElement = (e: any, viewer: any) => {
		const newRect = this.viewer.viewport.viewportToViewerElementRectangle(
			viewer.viewport.imageToViewportRectangle(e.rect)
		);
		const point = this.viewer.viewport.getFlip()
			? this.flipPoint(
					{ x: e.rect.x, y: e.rect.y },
					viewer.viewport.getRotation(),
					viewer.world.getItemAt(0).viewportToImageCoordinates(viewer.viewport.getCenter(true))
			  )
			: { x: e.rect.x, y: e.rect.y };
		const pos = viewer.viewport.viewportToViewerElementCoordinates(
			viewer.viewport.imageToViewportCoordinates(point.x, point.y)
		);
		e.element.style.left = pos.x - newRect.width / 2 + "px";
		e.element.style.top = pos.y - newRect.height / 2 + "px";
		e.element.style.width = newRect.width + "px";
		e.element.style.height = newRect.height + "px";
		if ("fontSize" in e) {
			e.element.style.fontSize = (e.fontSize * viewer.viewport.getZoom(true)) / viewer.viewport.getHomeZoom() + "px";
		}
	};

	public flipPoint = (p: any, angle: any, center: any) => {
		const rotatedPoint = this.rotatePoint(p, 180 + angle * 2, center);
		return { x: rotatedPoint.x, y: center.y * 2 - rotatedPoint.y };
	};

	public rotatePoint = (p: any, angle: any, center: any) => {
		angle = (angle * Math.PI) / 180;
		let point = center ? this.subtractPoints(p, center) : p,
			sin = Math.sin(angle),
			cos = Math.cos(angle);
		point = {
			x: point.x * cos - point.y * sin,
			y: point.x * sin + point.y * cos
		};
		return center ? this.addPoints(point, center) : point;
	};

	public subtractPoints = (p1: any, p2: any) => {
		return { x: p1.x - p2.x, y: p1.y - p2.y };
	};

	public addPoints = (p1: any, p2: any) => {
		return { x: p1.x + p2.x, y: p1.y + p2.y };
	};
	public addElement = (e: any) => {
		//if (this.validateElement(e))
		{
			e.element.style.width = "100%";
			e.element.style.height = "100%";
			let wrapperDiv = document.createElement("div");
			wrapperDiv.style.position = "absolute";
			wrapperDiv.appendChild(e.element);
			this.viewer.canvas.appendChild(wrapperDiv);
			this.elements.push({
				...e,
				element: wrapperDiv,
				rect: new OpenSeadragon.Rect(e.x + e.width / 2, e.y + e.height / 2, e.width, e.height)
			});
		}
		return this.elements;
	};
	public getElementById = (id: string) => {
		return this.elements.find((e: any) => {
			return e.id === id;
		});
	};
	public removeElementById = (id: string) => {
		const e = this.getElementById(id);
		if (e !== null) {
			this.viewer.canvas.removeChild(e.element);
			this.elements.splice(this.elements.indexOf(e), 1);
		}
		return this.elements;
	};
	public removeElementsById = (ids: string[]) => {
		for (let id of ids) {
			this.removeElementById(id);
		}
		return this.elements;
	};

	// temporarily set OpenSeadragon animation params
	// to a very slow animate, then restore.
	public withSlowOSDAnimation = (viewport: any, f: any, factor: number = 20) => {
		// save old ones
		var oldValues = {} as any;
		oldValues.centerSpringXAnimationTime = viewport.centerSpringX.animationTime;
		oldValues.centerSpringYAnimationTime = viewport.centerSpringY.animationTime;
		oldValues.zoomSpringAnimationTime = viewport.zoomSpring.animationTime;

		// set our new ones
		viewport.centerSpringX.animationTime = viewport.centerSpringY.animationTime = viewport.zoomSpring.animationTime = factor;

		// callback
		f();

		// restore values
		viewport.centerSpringX.animationTime = oldValues.centerSpringXAnimationTime;
		viewport.centerSpringY.animationTime = oldValues.centerSpringYAnimationTime;
		viewport.zoomSpring.animationTime = oldValues.zoomSpringAnimationTime;
	};
	private loadImage = (src: string) =>
		new Promise(function(resolve, reject) {
			var img = document.createElement("img");
			img.addEventListener("load", function() {
				resolve(img);
			});
			img.addEventListener("error", function(err) {
				reject(404);
			});
			img.src = src;
		});

	render() {
		let self = this;
		let { id } = this.props;
		return (
			<div
				className="ocd-div"
				ref={node => {
					this.el = node;
				}}>
				<div className="navigator-wrapper c-shadow">
					<div id="navigator" />
				</div>
				<div className="openseadragon" id={id} />
				{/* <ul className="ocd-toolbar">
					<li>
						<a id="zoom-in">
							<i className="fa fa-plus" />
						</a>
					</li>
					<li>
						<a id="reset">
							<i className="fa fa-circle" />
						</a>
					</li>
					<li>
						<a id="zoom-out">
							<i className="fa fa-minus" />
						</a>
					</li>
					<li>
						<a id="full-page">
							<i className="fa fa-cog" />
						</a>
					</li>
				</ul> */}
			</div>
		);
	}

	initSeaDragon = () => {
		let self = this;
		let { id, image, type } = this.props;
		self.viewer = new OpenSeadragon.Viewer({
			id: id,
			prefixUrl: "//cdnjs.cloudflare.com/ajax/libs/openseadragon/2.4.1/images/",
			tileSources: image,
			alwaysBlend: true,
			immediateRender: true,
			visibilityRatio: 1.1,
			//constrainDuringPan: false,
			//defaultZoomLevel: 1,
			//minZoomLevel: 1,
			//maxZoomLevel: 20,
			zoomInButton: "zoom-in",
			zoomOutButton: "zoom-out",
			homeButton: "reset",
			// fullPageButton: "full-page",
			// nextButton: "next",
			// previousButton: "previous",
			showNavigator: true,
			//navigatorId: "navigator",
			navigatorAutoFade: false,
			navigatorPosition: "BOTTOM_LEFT",
			blendTime: 0.5,
			preload: true,
			pixelsPerWheelLine: 40,
			//minScrollDeltaTime: 20
			zoomPerScroll: 1.7,
			gestureSettingsMouse: {
				clickToZoom: false,
				dblClickToZoom: true
			}
			//debugMode: true
			// overlays: [
			// 	{
			// 		id: "overlay",
			// 		x: 0,
			// 		y: 0,
			// 		width: 0.031249999999999979,
			// 		height: 0.031249999999999979,
			// 		className: "highlight"
			// 	}
			// ]
		});

		// var elt = document.getElementById("overlay");
		// elt!.id = "overlay";
		// elt!.className = "highlight";
		// self.viewer.addOverlay({
		// 	element: elt,
		// 	location: new OpenSeadragon.Rect(0.33, 0.75, 0.2, 0.25)
		// });

		//This sets up listerners for everything in self.elements as and when they are added
		for (var h of ["open", "animation", "rotate", "flip", "resize"]) {
			this.viewer.addHandler(h, function() {
				self.repositionElements(self.elements, self.viewer);
			});
		}

		//var hEl = (self.viewer as any).HTMLelements();

		// var textbox = document.createElement("div");
		// textbox.style.backgroundColor = "rgba(200,200,200,0.8)";
		// textbox.style.border = "solid 1px black";
		// textbox.style.borderRadius = "8px";
		// textbox.innerHTML =
		// 	"ipsum dolor amet brisket pork spare ribs drumstick cupim. Turducken pork chop drumstick meatball boudin spare ribs.";

		// this.addElement({
		// 	id: "gif",
		// 	element: textbox,
		// 	x: 0,
		// 	y: 0,
		// 	//width: self.viewer.viewport.viewportToImageCoordinates(new OpenSeadragon.Point(0.3)),
		// 	//height: self.viewer.viewport.viewportToImageCoordinates(new OpenSeadragon.Point(0.3))
		// 	width: 4125,
		// 	height: 4125,
		// 	fontSize: 14
		// });

		self.viewer.addHandler("open", target => {
			this.props.onOpen();
		});

		self.viewer.addHandler("canvas-click", target => {
			if (target.quick === true) {
				var viewportPoint = self.viewer.viewport.pointFromPixel(target.position);
				var imagePoint = self.viewer.viewport.viewportToImageCoordinates(viewportPoint.x, viewportPoint.y);
				imagePoint = self.viewer.viewport.viewportToImageCoordinates(0.0309, 0.0305);
				//console.log(parseInt(imagePoint.x), parseInt(imagePoint.y));
			}
		});

		const zoomHandler = Utils.throttled(250, (event: any) => self.props.onZoom(event.eventSource));
		self.viewer.addHandler("animation", zoomHandler);

		const mouseMoveHandler = Utils.throttled(200, (event: any) => self.props.onMouseMove(event));
		var tracker = new OpenSeadragon.MouseTracker({
			element: this.props.id,
			moveHandler: mouseMoveHandler
		});
		tracker.setTracking(true);

		if (this.props.showNavigator === false) {
			self.viewer.navigator.element.style.display = "none";
		}
		//self.viewer.addHandler("mousemove", event => mouseMoveHandler(event.eventSource));
		// setTimeout(() => {
		// 	var point = new OpenSeadragon.Point(0 + 0.031249999999999979 / 2, 0 + 0.031249999999999979 / 2);
		// 	self.viewer.viewport.panTo(point);
		// }, 2000);
		// setTimeout(() => {
		// 	var point = new OpenSeadragon.Point(0 + 0.031249999999999979 / 2, 0 + 0.031249999999999979 / 2);
		// 	self.viewer.viewport.zoomTo(14, point);
		// }, 5000);
	};

	componentDidMount() {
		this.initSeaDragon();
	}
	shouldComponentUpdate(nextProps: any, nextState: any) {
		return false;
	}
}

(OpenSeaDragonReact as any).defaultProps = { id: "ocd-viewer", type: "legacy-image-pyramid", showNavigator: true };
